import Swiper from 'swiper/bundle';

const homeSlider = () => {
  const sliderElement = document.getElementById('js-home-main-swiper');

  if (!sliderElement) {
    return;
  }


  let mainSwiper = new Swiper(sliderElement, { //eslint-disable-line
    loop: true,
    autoplay: {
      delay: 3000,
    },
    keyboard: {
      enabled: true,
    },
    navigation: {
      prevEl: '#js-home-main-swiper-prev',
      nextEl: '#js-home-main-swiper-next',
    },
    pagination: {
      el: '#js-home-main-swiper-pagination',
      clickable: true,
    },
    a11y: {
      prevSlideMessage: '前のスライドへ',
      nextSlideMessage: '次のスライドへ',
      slideLabelMessage: '{{index}}枚目のスライド',
      paginationBulletMessage: '{{index}}枚目のスライドを表示',
    },
  });
};

const homeCompanySlider = () => {
  const sliderElement = document.getElementById('js-home-company-slider');

  if (!sliderElement) {
    return;
  }

  const wrapper = sliderElement.querySelector('.swiper-wrapper');

  const slides = sliderElement.querySelectorAll('.swiper-slide');

  slides.forEach(slide => {
    const cloneSlide = slide.cloneNode(true);

    wrapper.appendChild(cloneSlide);
  });



  let mainSwiper = new Swiper(sliderElement, { //eslint-disable-line
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: true,
    simulateTouch: false,
    allowTouchMove: false,
    speed: 10000,

    autoplay: {
      delay: 0,
      // disableOnInteraction: false,
      // pauseOnMouseEnter: true,
    },

  });
};

const pageFootSlider = () => {
  const sliderElement = document.getElementById('js-pageFoot-swiper');
  if (!sliderElement) return;

  const slideLength = sliderElement.querySelectorAll('.swiper-slide').length;
  const buttons = sliderElement.closest('.c-pageFootSliderList').querySelectorAll('.c-pageFootSlider__button');

  const prevButton = document.querySelector('#js-pageFoot-slider-prev-button');
  const nextButton = document.querySelector('#js-pageFoot-slider-next-button');

  console.log(slideLength);

  const toggleButton = (Boolean = true) => {
    if (Boolean) {
      buttons.forEach(button => {
        button.disabled = false;
        button.classList.remove('swiper-button-lock');
      });
    } else {
      buttons.forEach(button => {
        button.disabled = true;
      });
    }

  };

  let swiper;
  let resizeFlag = 0;

  const createSwiper = (Boolean) => {

    swiper = new Swiper(sliderElement, { //eslint-disable-line
      loop: Boolean,
      keyboard: {
        enabled: true,
      },
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      a11y: {
        prevSlideMessage: '前のスライドへ',
        nextSlideMessage: '次のスライドへ',
        slideLabelMessage: '{{index}}枚目のスライド',
        paginationBulletMessage: '{{index}}枚目のスライドを表示',
      },
      breakpoints: {
        769: {
          slidesPerView: 'auto',
          spaceBetween: 25
        },
      }
    });
  };



  const swiperFunction = num => {
    console.log(slideLength);
    if (slideLength > num) {
      toggleButton(true);
      createSwiper(true);
    } else {
      toggleButton(false);
      createSwiper(false);
    }
    console.log(swiper.params);
  };

  const resetSwiper = () => {
    console.log('destroy');
    swiper.destroy(true, true);
    swiper = undefined;
  };


  const checkMediaQuery = () => {
    if (window.matchMedia("(min-width:960px)").matches) {
      if (swiper && resizeFlag !== 960) {
        resetSwiper();
      }

      if (!swiper) {
        console.log('960 init');
        swiperFunction(3);
      }

      resizeFlag = 960;
    } else if (window.matchMedia("(min-width:769px)").matches) {
      console.log('769');
      if (swiper && resizeFlag !== 769) {
        resetSwiper();
      }

      if (!swiper) {
        console.log('769 init');
        swiperFunction(2);
      }

      resizeFlag = 769;
    } else {

      if (swiper && resizeFlag !== 0) {
        resetSwiper();
      }

      if (!swiper) {
        console.log('else');
        swiperFunction(1);
      }
      resizeFlag = 0;

    }
  };

  checkMediaQuery();

  window.addEventListener('resize', checkMediaQuery);
};


export default () => {
  homeSlider();
  homeCompanySlider();
  pageFootSlider();
};
